import { render, staticRenderFns } from "./WaitingRoom.vue?vue&type=template&id=75834d66&scoped=true"
import script from "./WaitingRoom.vue?vue&type=script&lang=js"
export * from "./WaitingRoom.vue?vue&type=script&lang=js"
import style0 from "./WaitingRoom.vue?vue&type=style&index=0&id=75834d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75834d66",
  null
  
)

export default component.exports